module.exports = __webpack_public_path__ + "img/antes_despues_93.7496490c.png";